// Types partagés du formulateur cosmétique (front).
//
// Source unique des types de saisie : le hook (useFormulateur), le snapshot persisté
// (lib/formulesCosmetique) et les blocs d'UI s'y réfèrent. Évite le doublon de définition
// du snapshot qui existait dans le brouillon C3d1 perdu.

import type { IngredientDosage, PhaseId } from '@shared/cosmetique'

// Libellés lisibles des phases (source UNIQUE : consommé par le bloc de formulation ET par
// le pont « Fabriquer » vers la fiche de fabrication). Évite un doublon de mapping.
export const PHASE_LABEL: Record<PhaseId, string> = {
  phase_aqueuse: 'Phase aqueuse',
  phase_huileuse: 'Phase huileuse',
  emulsifiant: 'Émulsifiant',
  actifs: 'Actifs',
  conservateurs: 'Conservateurs',
  parfum: 'Parfum / senteur',
}

// Une ligne en cours de saisie : pourcentage gardé en TEXTE pendant la frappe, + données
// de dosage de l'ingrédient (perso) pour l'alerte live ; inci pour l'aperçu d'étiquetage.
export interface LigneSaisie {
  nom: string
  inci: string | null
  pct: string
  dosage?: IngredientDosage
}

// Snapshot persisté d'une formule cosmétique : infos produit + lignes par phase. C'est
// EXACTEMENT ce que le formulateur sait ré-enregistrer puis recharger. Le serveur le stocke
// tel quel (donnée opaque ; cf. shared/schemas/formule-cosmetique).
export interface FormuleCosmetiqueSnapshot {
  type_produit: string
  poids_total: number
  destine_enfants: boolean
  a_rincer: boolean
  lignes: Record<PhaseId, LigneSaisie[]>
}
